import { createAction, props } from '@ngrx/store';
import {
  HealthKPIAggregatedParameters,
  HealthKPIAggregatedResponseSchema,
  HealthKPIEnum,
  HealthKPILatestParameters,
  HealthKPILatestResponseSchema,
  SafetyRecommendationComponentDetailsInterface,
  SafetyRecommendationComponentDetailsParamsInterface,
  SafetyRecommendationDataInterface,
  SystemIngestionStatistics,
  GetSiblingEffectResponse,
} from '@twaice-fe/shared/models';

// region Safety Recommendation actions
export const fetchSafetyRecommendationData = createAction('[Energy Analytics] Fetch safety recommendation data');

export const loadSafetyRecommendationDataSuccess = createAction(
  '[Energy Analytics/API] Load safety recommendation data Success',
  props<{ safetyRecommendationData: SafetyRecommendationDataInterface }>()
);

export const loadSafetyRecommendationDataFailure = createAction(
  '[Energy Analytics/API] Load safety recommendation data Failure',
  props<{ error: string }>()
);

export const cancelSafetyRecommendationDataRequest = createAction(
  '[Energy Analytics/API] Cancel safety recommendation data http request'
);

export const fetchSafetyRecommendationComponentDetails = createAction(
  '[Energy Analytics] Fetch safety recommendation component details',
  props<SafetyRecommendationComponentDetailsParamsInterface>()
);

export const loadSafetyRecommendationComponentDetailsSuccess = createAction(
  '[Energy Analytics/API] Load safety recommendation component details Success',
  props<{ safetyRecommendationComponentDetails: SafetyRecommendationComponentDetailsInterface }>()
);

export const loadSafetyRecommendationComponentDetailsFailure = createAction(
  '[Energy Analytics/API] Load safety recommendation component details Failure',
  props<{ error: string }>()
);

export const cancelSafetyRecommendationComponentDetailsRequest = createAction(
  '[Energy Analytics/API] Cancel safety recommendation component details http request'
);

export const fetchSafetyMailNotificationConfig = createAction(
  '[Energy Analytics Safety/Mail Notifications] Fetch mail configuration'
);
export const fetchSafetyMailNotificationConfigSuccess = createAction(
  '[Energy Analytics Safety/Mail Notifications] Fetch mail configuration success',
  props<{ notificationsEnabled: boolean }>()
);
export const fetchSafetyMailNotificationConfigFailure = createAction(
  '[Energy Analytics Safety/Mail Notifications] Fetch mail configuration failure',
  props<{ error: any }>()
);
export const updateSafetyMailNotificationConfig = createAction(
  '[Energy Analytics Safety/Mail Notifications] Update mail configuration',
  props<{ notificationsEnabled: boolean }>()
);
export const updateSafetyMailNotificationConfigSuccess = createAction(
  '[Energy Analytics Safety/Mail Notifications] Update mail configuration success',
  props<{ notificationsEnabled: boolean }>()
);
export const updateSafetyMailNotificationConfigFailure = createAction(
  '[Energy Analytics Safety/Mail Notifications] Update mail configuration failure',
  props<{ error: any }>()
);

// endregion

// region  System Ingestion Statistics Actions
export const fetchSystemIngestionStatisticsData = createAction('[Energy Analytics] Fetch system ingestion statistics data');

export const loadSystemIngestionStatisticsSuccess = createAction(
  '[Energy Analytics/API] Load system ingestion statistics data Success',
  props<{ systemIngestionStatistics: SystemIngestionStatistics }>()
);

export const loadSystemIngestionStatisticsFailure = createAction(
  '[Energy Analytics/API] Load system ingestion statistics data Failure',
  props<{ error: string }>()
);

export const cancelSystemIngestionStatisticsRequest = createAction(
  '[Energy Analytics/API] Cancel system ingestion statistics data http request'
);
// endregion

// region has sibling effect Actions
export const fetchHasSiblingEffect = createAction('[Energy Analytics] Fetch has sibling effect data');

export const loadHasSiblingEffectSuccess = createAction(
  '[Energy Analytics/API] Load has sibling effect data Success',
  props<{ hasSiblingEffect: GetSiblingEffectResponse }>()
);

export const loadHasSiblingEffectFailure = createAction(
  '[Energy Analytics/API] Load has sibling effect data Failure',
  props<{ error: string }>()
);

export const cancelHasSiblingEffectRequest = createAction('[Energy Analytics/API] Cancel has sibling effect data http request');
// endregion

// region Health KPIs
export const fetchLatestHealthKPIData = createAction(
  '[Energy Analytics] Fetch latest health kpi data',
  props<{ kpi: HealthKPIEnum; params: HealthKPILatestParameters }>()
);

export const fetchAggregatedHealthKPIData = createAction(
  '[Energy Analytics] Fetch aggregated health kpi data',
  props<{ kpi: HealthKPIEnum; params: HealthKPIAggregatedParameters }>()
);

export const loadLatestHealthKPIDataSuccess = createAction(
  '[Energy Analytics/API] Load latest health kpi data Success',
  props<HealthKPILatestResponseSchema>()
);

export const loadAggregatedHealthKPIDataSuccess = createAction(
  '[Energy Analytics/API] Load aggregated health kpi data Success',
  props<HealthKPIAggregatedResponseSchema>()
);

export const loadLatestHealthKPIDataFailure = createAction(
  '[Energy Analytics/API] Load latest health kpi data failure',
  props<{ kpi: HealthKPIEnum; error: string }>()
);

export const loadAggregatedHealthKPIDataFailure = createAction(
  '[Energy Analytics/API] Load aggregated health kpi data failure',
  props<{ kpi: HealthKPIEnum; error: string }>()
);

export const cancelHealthKPIDataRequest = createAction('[Energy Analytics/API] Cancel health kpi data http request');
// endregion
